import React from 'react';

const GRID_COLOR = 'rgba(10, 18, 18, 0.6)';
const GLOW_COLOR = 'rgba(57, 229, 245, 0.25)';
const TEXT_COLOR = '#6ee8f5';

export default function AirdropPage() {
  return (
    <div className="relative flex min-h-[calc(100vh-56px)] items-center justify-center overflow-hidden bg-[var(--page-bg,#050505)] px-4 py-10">
      <div
        className="pointer-events-none absolute inset-0 opacity-60"
        aria-hidden
        style={{
          backgroundImage: `
            linear-gradient(90deg, ${GRID_COLOR} 1px, transparent 1px),
            linear-gradient(180deg, ${GRID_COLOR} 1px, transparent 1px)
          `,
          backgroundSize: '84px 84px',
          backgroundPosition: '-36px 0',
          mixBlendMode: 'screen',
        }}
      />
      <div
        className="pointer-events-none absolute inset-0"
        aria-hidden
        style={{
          background: `radial-gradient(50% 50% at 50% 50%, ${GLOW_COLOR} 0%, rgba(5, 5, 5, 0) 60%)`,
        }}
      />
      <div className="relative text-center">
        <h1
          className="font-[var(--font-jakarta)] text-[clamp(48px,10vw,110px)] font-extrabold leading-tight text-[#39e5f5]"
          style={{
            textShadow: '0 0 250px #39e5f5',
            WebkitTextFillColor: 'transparent',
            WebkitTextStroke: '0',
            backgroundImage: `linear-gradient(${TEXT_COLOR}, ${TEXT_COLOR})`,
            WebkitBackgroundClip: 'text',
          }}
        >
          Coming Soon
        </h1>
      </div>
    </div>
  );
}
